export default "data:image/svg+xml,au.svg"